import React, { useState, useEffect } from 'react';

const defaultImageSvg = () => {
  // SVG simples com ícone de imagem (placeholder)
  const svg = `
    <svg width="300" height="300" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#E5E7EB;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#D1D5DB;stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#grad)"/>
      <g transform="translate(150, 150)">
        <rect x="-40" y="-30" width="80" height="60" fill="none" stroke="#9CA3AF" stroke-width="2" rx="4"/>
        <circle cx="-20" cy="-15" r="6" fill="#9CA3AF"/>
        <path d="M-40 -30 L20 -30 L30 30 L-30 30 Z" fill="none" stroke="#9CA3AF" stroke-width="2"/>
      </g>
    </svg>
  `.replace(/\s+/g, ' ').trim();
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

const ImageWithFallback = ({
  src,
  alt = '',
  className = '',
  fallbackText = '',
  ...props
}) => {
  const [imgSrc, setImgSrc] = useState(src || defaultImageSvg());
  const [hasError, setHasError] = useState(!src);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
      setImgSrc(defaultImageSvg());
    }
  };

  useEffect(() => {
    if (src && src.trim() !== '') {
      setImgSrc(src);
      setHasError(false);
    } else {
      setHasError(true);
      setImgSrc(defaultImageSvg());
    }
  }, [src]);

  return (
    <img
      src={imgSrc}
      alt={alt || fallbackText || 'Imagem do produto'}
      className={className}
      onError={handleError}
      {...props}
    />
  );
};

export default ImageWithFallback;


